import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import dropdownvertical from '../assets/images/drop_vertical.svg';
import only_free from '../assets/images/only_free.svg';
import verified from '../assets/images/verified.svg';
import all_list from '../assets/images/all_list.svg';
import refresh from '../assets/images/refresh.svg';
import whitedrop_down from '../assets/images/whitedrop_down.svg';
import default_user from '../assets/images/default_user.webp';
import default_header_image from '../assets/images/default_header_image.png';
import premiumicon from '../assets/images/sale-03.svg';
import HomeCreatePost from '../components/HomeCreatePost';
import PillsNotification from '../components/PillsNotification';
import HomeSidebarFooterLinks from '../components/HomeSidebarFooterLinks';
import SidebarSearch from '../components/SidebarSearch';
import config from '../config/config'; 

const Notifications = () => {
  const [isRestricted, setIsRestricted] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [showOnlyFree, setShowOnlyFree] = useState(false);
  const [freeIcon, setFreeIcon] = useState(only_free); 
  const [restrictedUsers, setRestrictedUsers] = useState(new Set());
  const [blockedUsers, setBlockedUsers] = useState(new Set());
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(false); 
  const [reportReason, setReportReason] = useState('');
  const [selectedReportReason, setSelectedReportReason] = useState('');
  const [showSaveToListModal, setShowSaveToListModal] = useState({ visible: false, userId: null });
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [listName, setListName] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [userLists, setUserLists] = useState([]); 
  const [apiResponseMessage, setApiResponseMessage] = useState('');
  const navigate = useNavigate();
  const [checkedLists, setCheckedLists] = useState(new Set());
  const { username } = useParams();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
    }
  }, [navigate]);

const fetchProfiles = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const url = `${config.baseURL}/get-creators${showOnlyFree ? '?showonlyfree=true' : ''}`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setProfiles(data.data);

        // Initialize blockedUsers and restrictedUsers states
        const blocked = new Set();
        const restricted = new Set();
        data.data.forEach(profile => {
          if (profile.user_details.is_blocked) blocked.add(profile.user.id);
          if (profile.user_details.is_restricted) restricted.add(profile.user.id);
        });
        setBlockedUsers(blocked);
        setRestrictedUsers(restricted);

        setErrorMessage('');
      } else {
        setErrorMessage('Failed to fetch profiles');
      }
    } catch (error) {
      setErrorMessage('Error fetching profiles');
    }
  }, [showOnlyFree]);

  useEffect(() => {
    fetchProfiles();
  }, [fetchProfiles]);


const fetchUserLists = async () => {
  try {
    const token = localStorage.getItem('token');
    const url = `${config.baseURL}/get-users-list`;
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await response.json();

    if (data.success) {
      setUserLists(data.data);

      // Initialize checkedLists state based on whether the user is in any list
      const initialCheckedLists = new Set(
        data.data
          .filter(list => list.users.some(user => user.id === showSaveToListModal.userId))
          .map(list => list.id)
      );
      setCheckedLists(initialCheckedLists);
    } else {
      setUserLists([]);
      setCheckedLists(new Set()); // Reset the checked lists if there's an error
    }
  } catch (error) {
    console.error('Error fetching user lists:', error);
    setUserLists([]);
    setCheckedLists(new Set()); // Reset the checked lists in case of an error
  }
};

useEffect(() => {
  if (showSaveToListModal) {
    fetchUserLists();
  }
}, [showSaveToListModal]);




const handleCheckboxChange = async (listId, userId, isChecked) => {
  const url = `${config.baseURL}/${isChecked ? 'add-user-to-list' : 'remove-user-from-list'}`;
  const params = new URLSearchParams();
  params.append('user_list_id', listId);
  params.append('listed_user_id', userId);

  try {
    const token = localStorage.getItem('token'); // Assuming token is stored in local storage
    const response = await axios.post(url, params, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    console.log('Response:', response.data);

    setCheckedLists(prevCheckedLists => {
      const updatedCheckedLists = new Set(prevCheckedLists);
      if (isChecked) {
        updatedCheckedLists.add(listId);
      } else {
        updatedCheckedLists.delete(listId);
      }
      return updatedCheckedLists;
    });

  } catch (error) {
    console.error('Error updating user list:', error);
  }
};

  const handleShowOnlyFreeClick = () => {
    setShowOnlyFree(prevState => !prevState);
    setFreeIcon(prevState => prevState === only_free ? all_list : only_free);
  };

  const handleRefreshClick = () => {
    fetchProfiles();
  };

  const handleCopyLink = (userName) => {
    const profileUrl = `${window.location.origin}/${userName}`;
    navigator.clipboard.writeText(profileUrl)
      .then(() => {
        setToastMessage('Profile link copied to clipboard!');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      })
      .catch(() => {
        setErrorMessage('Error copying link');
      });
  };

 const handleRestrictUser = async (userId) => {
    try {
      const token = localStorage.getItem('token');
      const isRestricted = restrictedUsers.has(userId);
      const url = isRestricted ? `${config.baseURL}/unrestrict-user` : `${config.baseURL}/restrict-user`;
      const formData = isRestricted ? { unrestrict_user_id: userId } : { restrict_to: userId };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(formData)
      });

      const data = await response.json();
      if (data.success) {
        setRestrictedUsers(prevState => {
          const newState = new Set(prevState);
          if (isRestricted) {
            newState.delete(userId);
          } else {
            newState.add(userId);
          }
          return newState;
        });
        setToastMessage(isRestricted ? 'User unrestricted successfully!' : 'User restricted successfully!');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        setErrorMessage('');
      } else {
        setErrorMessage(isRestricted ? 'Failed to unrestrict user' : 'Failed to restrict user');
      }
    } catch (error) {
      setErrorMessage(isRestricted ? 'Error unrestricting user' : 'Error restricting user');
    }
  };

  const handleBlockUser = async (userId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseURL}/block-user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({ block_to: userId })
      });
      const data = await response.json();
      if (data.success) {
        setBlockedUsers(prevState => new Set(prevState).add(userId));
        setToastMessage('User blocked successfully!');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        setErrorMessage('');
      } else {
        setErrorMessage('Failed to block user');
      }
    } catch (error) {
      setErrorMessage('Error blocking user');
    }
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

const handleUnblockUser = async (userId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseURL}/unblock-user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({ unblock_user_id: userId })
      });
      const data = await response.json();
      if (data.success) {
        setBlockedUsers(prevState => {
          const newState = new Set(prevState);
          newState.delete(userId);
          return newState;
        });
        setToastMessage('User unblocked successfully!');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        setErrorMessage('');
      } else {
        setErrorMessage('Failed to unblock user');
      }
    } catch (error) {
      setErrorMessage('Error unblocking user');
    }
  };

  const handleReportUser = (userId) => {
    setSelectedReportReason(''); // Reset the selected reason
    setReportReason(userId); // Set the userId for the report
    setShowModal(true);
  };

const handleShowSaveToListModal = (userId) => {
  console.log('Show Save to List Modal for userId:', userId);
  setShowSaveToListModal({ visible: true, userId });
};

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseURL}/report-user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({ report_to: reportReason, reason: selectedReportReason })
      });
      const data = await response.json();
      if (data.success) {
        setToastMessage('User reported successfully!');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        setErrorMessage('');
      } else {
        setErrorMessage('Failed to report user');
      }
    } catch (error) {
      setErrorMessage('Error reporting user');
    } finally {
      setShowModal(false);
    }
  };

  const handleSaveToListClick = () => {
    setShowSaveToListModal(true);
  };

  const handleCreateListClick = () => {
    setShowSaveToListModal(false);
    setShowCreateListModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const reportReasons = [
    'Violates OnlyFans Terms of Service',
    'Contains copyrighted material (DMCA)',
    'Child Sexual Abuse Material (CSAM)',
    'Report Spam',
    'Report Abuse'
  ];


  useEffect(() => {
    // Initialize the checked state based on userLists if needed
  }, [userLists]);


const handleCreateListSubmit = async (e) => {
  e.preventDefault();
  try {
    if (listName.trim() === '') {
      setErrorMessage('List name cannot be empty');
      return;
    }
    if (listName.length > 64) {
      setErrorMessage('List name cannot exceed 64 characters');
      return;
    }

    const token = localStorage.getItem('token');
    const response = await fetch(`${config.baseURL}/create-user-list`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({ title: listName }) // Use 'title' instead of 'list_name'
    });

    const data = await response.json();
    if (data.success) {
      setApiResponseMessage('List created successfully!');
      setShowCreateListModal(false);
      setListName(''); // Clear list name
      setWordCount(0); // Reset word count
    } else {
      setApiResponseMessage('Failed to create list');
    }
  } catch (error) {
    setApiResponseMessage('Error creating list');
  }
};

  useEffect(() => {
    document.title = "Notifications - PatreonPass";
  }, []);


 const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };



  return (
    <div>
      <div className="main_patreonpass_wrapper"> 
          <div className="patreonpass_container">
            <div className="left_sidebar">
              <MainSidebar />
            </div>
            <div className="patreonpass_main_content" id="content">
              <div className="left_main_content">
                <div className="feed_wrapper"> 
                      <div className="page_title_with_dropdown notification_page">
                        <div className="page_heading">
                          <button className="profile_back_btn" onClick={handleBackClick}>
                            <svg
                              width={54}
                              height={54}
                              viewBox="0 0 54 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                                stroke="#222"
                                strokeWidth={6}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                          <h1>Notifications</h1>
                        </div>
                        <div className="head_dropdown">
                          <ul>
                            <li className="nav-item dropdown">                                
                                <Link to="/notificationsettings">
                                <svg
                                  className="icon_dropdown"
                                  width={38}
                                  height={38}
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_74_296)">
                                    <path
                                      d="M18.9993 23.7498C21.6227 23.7498 23.7493 21.6232 23.7493 18.9998C23.7493 16.3765 21.6227 14.2498 18.9993 14.2498C16.376 14.2498 14.2493 16.3765 14.2493 18.9998C14.2493 21.6232 16.376 23.7498 18.9993 23.7498Z"
                                      stroke="#222222"
                                      strokeWidth="2.60563"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M29.6509 23.318C29.4593 23.7522 29.4021 24.2338 29.4868 24.7007C29.5714 25.1676 29.794 25.5985 30.1259 25.9377L30.2122 26.0241C30.4799 26.2914 30.6922 26.6089 30.8371 26.9584C30.982 27.3079 31.0565 27.6825 31.0565 28.0608C31.0565 28.4391 30.982 28.8137 30.8371 29.1632C30.6922 29.5127 30.4799 29.8302 30.2122 30.0976C29.9449 30.3652 29.6274 30.5776 29.2779 30.7224C28.9284 30.8673 28.5538 30.9419 28.1755 30.9419C27.7972 30.9419 27.4226 30.8673 27.0731 30.7224C26.7236 30.5776 26.4061 30.3652 26.1387 30.0976L26.0524 30.0112C25.7131 29.6794 25.2823 29.4568 24.8153 29.3721C24.3484 29.2874 23.8668 29.3446 23.4327 29.5362C23.007 29.7187 22.6439 30.0216 22.3881 30.4078C22.1324 30.794 21.9951 31.2465 21.9933 31.7097V31.9544C21.9933 32.7179 21.69 33.4501 21.1501 33.99C20.6102 34.5299 19.878 34.8332 19.1145 34.8332C18.351 34.8332 17.6188 34.5299 17.0789 33.99C16.539 33.4501 16.2357 32.7179 16.2357 31.9544V31.8248C16.2246 31.3484 16.0704 30.8863 15.7931 30.4987C15.5159 30.1111 15.1284 29.8159 14.6812 29.6514C14.247 29.4597 13.7654 29.4026 13.2985 29.4873C12.8316 29.5719 12.4007 29.7945 12.0615 30.1264L11.9751 30.2127C11.7077 30.4804 11.3902 30.6927 11.0408 30.8376C10.6913 30.9825 10.3167 31.057 9.93836 31.057C9.56005 31.057 9.18544 30.9825 8.83596 30.8376C8.48648 30.6927 8.16898 30.4804 7.90162 30.2127C7.63396 29.9454 7.42163 29.6279 7.27675 29.2784C7.13188 28.9289 7.05731 28.5543 7.05731 28.176C7.05731 27.7977 7.13188 27.4231 7.27675 27.0736C7.42163 26.7241 7.63396 26.4066 7.90162 26.1392L7.98799 26.0529C8.31982 25.7136 8.54242 25.2828 8.62708 24.8158C8.71175 24.3489 8.65459 23.8673 8.46299 23.4332C8.28052 23.0074 7.97756 22.6444 7.59138 22.3886C7.20521 22.1329 6.75268 21.9956 6.2895 21.9938H6.0448C5.2813 21.9938 4.54907 21.6905 4.00919 21.1506C3.46932 20.6107 3.16602 19.8785 3.16602 19.115C3.16602 18.3515 3.46932 17.6193 4.00919 17.0794C4.54907 16.5395 5.2813 16.2362 6.0448 16.2362H6.17435C6.65078 16.2251 7.11284 16.0708 7.50046 15.7936C7.88808 15.5164 8.18333 15.1289 8.34783 14.6817C8.53944 14.2475 8.5966 13.7659 8.51193 13.299C8.42727 12.8321 8.20467 12.4012 7.87283 12.062L7.78647 11.9756C7.51881 11.7082 7.30647 11.3907 7.1616 11.0413C7.01673 10.6918 6.94216 10.3172 6.94216 9.93885C6.94216 9.56054 7.01673 9.18593 7.1616 8.83645C7.30647 8.48697 7.51881 8.16947 7.78647 7.90211C8.05383 7.63445 8.37133 7.42211 8.72081 7.27724C9.07029 7.13237 9.4449 7.0578 9.82321 7.0578C10.2015 7.0578 10.5761 7.13237 10.9256 7.27724C11.2751 7.42211 11.5926 7.63445 11.86 7.90211L11.9463 7.98847C12.2856 8.32031 12.7164 8.54291 13.1834 8.62757C13.6503 8.71223 14.1319 8.65508 14.566 8.46347H14.6812C15.1069 8.28101 15.47 7.97805 15.7257 7.59187C15.9815 7.2057 16.1187 6.75317 16.1206 6.28999V6.04529C16.1206 5.28179 16.4239 4.54956 16.9637 4.00968C17.5036 3.4698 18.2358 3.1665 18.9993 3.1665C19.7629 3.1665 20.4951 3.4698 21.035 4.00968C21.5748 4.54956 21.8781 5.28179 21.8781 6.04529V6.17484C21.88 6.63801 22.0172 7.09054 22.273 7.47672C22.5287 7.8629 22.8918 8.16586 23.3175 8.34832C23.7517 8.53993 24.2333 8.59708 24.7002 8.51242C25.1671 8.42776 25.598 8.20516 25.9372 7.87332L26.0236 7.78696C26.291 7.5193 26.6085 7.30696 26.9579 7.16209C27.3074 7.01722 27.682 6.94265 28.0603 6.94265C28.4387 6.94265 28.8133 7.01722 29.1627 7.16209C29.5122 7.30696 29.8297 7.5193 30.0971 7.78696C30.3647 8.05432 30.5771 8.37182 30.7219 8.7213C30.8668 9.07078 30.9414 9.44538 30.9414 9.8237C30.9414 10.202 30.8668 10.5766 30.7219 10.9261C30.5771 11.2756 30.3647 11.5931 30.0971 11.8604L30.0107 11.9468C29.6789 12.286 29.4563 12.7169 29.3716 13.1838C29.287 13.6508 29.3441 14.1324 29.5357 14.5665V14.6817C29.7182 15.1074 30.0211 15.4705 30.4073 15.7262C30.7935 15.982 31.246 16.1192 31.7092 16.121H31.9539C32.7174 16.121 33.4496 16.4244 33.9895 16.9642C34.5294 17.5041 34.8327 18.2363 34.8327 18.9998C34.8327 19.7633 34.5294 20.4956 33.9895 21.0354C33.4496 21.5753 32.7174 21.8786 31.9539 21.8786H31.8244C31.3612 21.8805 30.9086 22.0177 30.5225 22.2735C30.1363 22.5292 29.8333 22.8923 29.6509 23.318Z"
                                      stroke="#222222"
                                      strokeWidth="2.60563"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_74_296">
                                      <rect width={38} height={38} fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                </Link>
                            </li>
                          </ul>
                        </div>
                      </div>                      
                      <PillsNotification message={toastMessage} show={showToast} /> 
                </div>
              </div>
              <div className="right_main_content">
                <SidebarSearch />
                <div className="suggestion_box">
                  <div className="title_header">
                    <h2> SUGGESTIONS</h2>
                    <div className="only_free right_side_icons">
                      <Link className="free_only" onClick={handleShowOnlyFreeClick}>
                        <img src={freeIcon} alt="" />
                      </Link>
                    </div>
                    <div className="only_free right_side_icons">
                      <Link className="refresh_list" onClick={handleRefreshClick}>
                        <img src={refresh} alt="" />
                      </Link>
                    </div>                    
                  </div>
                  <div className="free_user_list">
                    <div className="swiper-container">
                      <div className="swiper-wrapper">                          
                        {profiles.map((profile) => (
                        <div key={profile.user.id} className="swiper-slide">
                          <div className="profile_info_card">
                            <div className="profile_info_card_link">
                              <div className="profile_item_cover">
                                <Link to={`/${profile.user.user_name}`}>
                                <img
                                  src={profile.user_details.user_back_profile || default_header_image}
                                  alt="Profile background"
                                />
                                </Link>
                              </div>
                              <div className="free_list">
                                {profile.user.subs_type === 'free' ? 'Free' : <img src={premiumicon} alt="Premium" />}
                              </div>
                              <div className="more_options">
                                <div className="head_dropdown">
                                  <ul>
                                    <li className="nav-item dropdown">
                                      <a
                                        className="nav-link dropdown-toggle"
                                        href="#"
                                        id={`productsDropdown-${profile.user.id}`}
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <img
                                          className="icon_dropdown"
                                          src={whitedrop_down}
                                          alt="Dropdown"
                                        />
                                      </a>
                                      <ul
                                        className="dropdown-menu"
                                        aria-labelledby={`productsDropdown-${profile.user.id}`}
                                      >
                                        <li className="dropdown">
                                          <a className="dropdown-item" href={`/${profile.user.user_name}`}>
                                            <span className={`user_dropdown ${profile.user.status === 'active' ? 'user_online_status' : ''}`}>
                                              <img
                                                src={profile.user_details.user_profile || default_user}
                                                alt="User"
                                              />
                                            </span>{" "}
                                            @{profile.user.user_name}
                                          </a>
                                        </li>
                                        <hr className="dropdown-divider" />
                                        <li className="dropdown">
                                          <a className="dropdown-item" onClick={() => handleCopyLink(profile.user.user_name)}>
                                            Copy link to profile
                                          </a>
                                        </li>
                                        <li className="dropdown">
                                          <a className="dropdown-item" onClick={() => handleShowSaveToListModal(profile.user.id)}>
                                            Add to / remove from lists
                                          </a>
                                        </li>
                                        <hr className="dropdown-divider" />
                                        <li className="dropdown">
                                          <a
                                            className="dropdown-item danger_link"
                                            href="#"
                                            onClick={() => handleRestrictUser(profile.user.id)}
                                          >
                                            {restrictedUsers.has(profile.user.id) ? 'Unrestrict' : 'Restrict'}
                                          </a>
                                        </li>
                                        <li className="dropdown">
                                          <a
                                            className={`dropdown-item ${blockedUsers.has(profile.user.id) ? 'danger_link' : 'success_link'}`}
                                            onClick={() => blockedUsers.has(profile.user.id) ? handleUnblockUser(profile.user.id) : handleBlockUser(profile.user.id)}
                                          >
                                            {blockedUsers.has(profile.user.id) ? 'Unblock' : 'Block'}
                                          </a>
                                        </li>
                                        <li className="dropdown">
                                          <a
                                            className="dropdown-item danger_link"
                                            onClick={() => handleReportUser(profile.user.id)}
                                          >
                                            Report
                                          </a>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="profile_content">
                                <div className={`profile_avatar ${profile.user.online_status === 'online' ? 'user_online_status' : ''}`}>
                                  <Link to={`/${profile.user.user_name}`} className="profile_link">
                                    {profile.user_details.user_profile ? (
                                      <img
                                        src={profile.user_details.user_profile}
                                        alt="Profile"
                                      />
                                    ) : (
                                      <span className="profile_name_none_image">
                                      {getInitials(profile.user.name)}
                                      </span>
                                    )}
                                  </Link>
                                </div>
                                <div className="profile_name">
                                  <Link to={`/${profile.user.user_name}`}>{profile.user.name} </Link>
                                  <svg className="home_sidebar_user_verify" width={16} height={16} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M61.6076 13.7848L56.9968 6.10012C56.9652 6.04751 56.8964 6.03362 56.849 6.07253C52.6506 9.51474 42.1011 14.213 32.6436 6.08581C32.594 6.04321 32.5175 6.05367 32.4878 6.11189C30.1809 10.6355 22.8439 19.7553 11.3791 21.0382C11.3194 21.0449 11.2772 21.0993 11.2905 21.1579C12.475 26.3811 12.658 38.0206 4.1023 43.8173C4.05005 43.8527 4.03933 43.9254 4.08371 43.9702C8.22706 48.1592 15.3163 58.6835 11.3288 68.1314C11.3002 68.1992 11.3472 68.2756 11.4207 68.274C16.3178 68.1652 26.8065 70.985 30.9447 83.2021C30.9659 83.2648 31.039 83.2941 31.0941 83.2573C35.9852 79.9892 47.7732 75.534 56.8267 83.2349C56.8796 83.2799 56.9615 83.2638 56.9867 83.1991C58.9473 78.1609 65.5991 68.3556 77.0421 68.2789C77.1088 68.2785 77.1593 68.2175 77.1409 68.1533C75.4455 62.2367 74.8734 49.3511 85.8645 43.952C85.9282 43.9207 85.9427 43.834 85.8903 43.7863L80.2911 38.6962"
                                      stroke="#fefefe"
                                      strokeWidth={6}
                                      strokeLinecap="round"
                                    />
                                    <path
                                      d="M30.9874 39.2152L44.481 51.6709L81.3291 15.3418"
                                      stroke="#fefefe"
                                      strokeWidth={6}
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                </div>
                                <div className="profile_user_name">@{profile.user.user_name}</div>
                              </div>
                            </div>

                          </div>
                        </div>
                      ))} 

                      </div>
                      <div className="swiper-pagination" />
                    </div>
                  </div>
                </div>
                <HomeSidebarFooterLinks />
              </div>
            </div>
          </div>
        </div>

        <div className="share_text">
             {errorMessage && <div className="error_message">{errorMessage}</div>}
             {showToast && <div className="toast_message">{toastMessage}</div>}
        </div>

      {/* Save to List Modal */}
      {showSaveToListModal.visible && (
          <>
            <div className="modal-overlay" onClick={() => setShowSaveToListModal({ visible: false, userId: null })}></div>
            <div className="modal restoreAccessModalAccess save_list_popup fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="saveToListModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="saveToListModalLabel">SAVE TO LIST</h5>
                  </div>
                  <div className="modal-body">
                    {userLists.length === 0 ? (
                      <div className="no_list_message">Nothing found</div>
                    ) : (
                      <ul>
                        {userLists.map(list => (
                          <li key={list.id}>
                            <div className="list_wrap_popup">
                              <div className="m-checkbox-row checkbox_table">
                                <input
                                  type="checkbox"
                                  checked={checkedLists.has(list.id)}
                                  onChange={(e) => {
                                    const userId = showSaveToListModal.userId;
                                    console.log(`Checkbox changed for listId: ${list.id}, userId: ${userId}`);
                                    handleCheckboxChange(list.id, userId, e.target.checked);
                                  }}
                                  id={`checkbox-${list.id}`}
                                />
                                <label htmlFor={`checkbox-${list.id}`} className="g-input__wrapper"></label>
                              </div>
                              <div className="list_popup">
                                <div className="list_popup_left">
                                  <span>{list.title}</span>
                                  <small>{list.user_count} user</small>
                                </div>
                                <div className="list_popup_right">
                                  {list.users && list.users.length > 0 ? (
                                    list.users.map(user => (
                                      <img
                                        key={user.id}
                                        src={user.profile_image || default_user}
                                        alt={user.title}
                                        style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                                      />
                                    ))
                                  ) : (
                                    <img
                                      src={list.profile_image || default_user}
                                      alt={list.title}
                                      style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary cancel_btn" onClick={handleCreateListClick}>
                      <svg
                        enableBackground="new 0 0 50 50"
                        height="20px"
                        id="Layer_1"
                        version="1.1"
                        viewBox="0 0 50 50"
                        width="20px"
                        xmlSpace="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect fill="none" height={20} width={20} />
                        <line
                          fill="none"
                          stroke="#00aff0"
                          strokeMiterlimit={10}
                          strokeWidth={4}
                          x1={9}
                          x2={41}
                          y1={25}
                          y2={25}
                        />
                        <line
                          fill="none"
                          stroke="#00aff0"
                          strokeMiterlimit={10}
                          strokeWidth={4}
                          x1={25}
                          x2={25}
                          y1={9}
                          y2={41}
                        />
                      </svg>
                      New list
                    </button>
                    <button type="button" className="btn btn-secondary cancel_btn" onClick={() => setShowSaveToListModal({ visible: false, userId: null })}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}





      {/* Create New List Modal */}
      {showCreateListModal && (
        <>
          <div className="modal-overlay" onClick={() => setShowCreateListModal(false)}></div>
          <div id="restoreAccessForm" className="modal restoreAccessModalAccess fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="createListModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="createListModalLabel">CREATE NEW LIST</h5>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleCreateListSubmit}>
                    <div className="position_relative">
                      <input
                        type="text"
                        className="form-control"
                        value={listName}
                        onChange={(e) => {
                          setListName(e.target.value);
                          setWordCount(e.target.value.length);
                        }}
                        maxLength="64"
                        placeholder=""
                      />
                      <label htmlFor="listname" className="placeholder-label">List Name</label>
                      <div className="word_count">{wordCount} / 64</div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-primary send_btn" onClick={() => setShowCreateListModal(false)}>Cancel</button>
                      <button type="submit" className="btn btn-primary send_btn">Save</button>
                    </div>
                  </form>
                  {apiResponseMessage && <p>{apiResponseMessage}</p>}
                </div>
              </div>
            </div>
          </div>
        </>
      )}


      {/* Toast for user feedback */}
      {showToast && (
        <div className="toast">
          <p>{toastMessage}</p>
        </div>
      )}
      {errorMessage && (
        <div className="error">
          <p>{errorMessage}</p>
        </div>
      )}

       {showModal && (
          <>
            <div className="modal-overlay" onClick={handleCloseModal}></div>
            <div className="modal restoreAccessModalAccess fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="restoreAccessModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="restoreAccessModalLabel">Report</h5>
                  </div>
                  <div className="modal-body">
                    <form id="reportUserForm" onSubmit={handleModalSubmit}>
                      <div className="form-group">
                        {reportReasons.map((reason, index) => (
                          <div className="form-check" key={index}>
                            <input 
                              className="form-check-input" 
                              type="radio" 
                              name="reportReason" 
                              id={`reportReason${index}`} 
                              value={reason} 
                              onChange={(e) => setSelectedReportReason(e.target.value)} 
                              required 
                            />
                            <label className="form-check-label" htmlFor={`reportReason${index}`}>
                              {reason}
                            </label>
                          </div>
                        ))}
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary cancel_btn" onClick={handleCloseModal}>Cancel</button>
                        <button type="submit" className="btn btn-primary send_btn" disabled={!selectedReportReason}>Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

    </div>
  );
};

export default Notifications;


